module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product16-1c2ffb0be1b68388d2fd4763157671d6.jpg";